<template>
  <div>
    <BaseAccordion title="Added Truckers" :is-open="true">
      <template v-slot:title>
        <div class="d-flex align-items-center" style="gap: 4px; margin-right: 24px;">
          <RoundedButton
            v-for="status in truckerStatus"
            :key="status.text"
            type="filter"
            :active="activeTruckerStatus === status.text"
            @click.stop="activeTruckerStatus = activeTruckerStatus === status.text ? null : status.text"
          >
            {{ status.text | capitalize }}
          </RoundedButton>
        </div>
      </template>

      <AddedTruckersList :status="activeTruckerStatus" :order="order" :refresh="truckerRefresh" @refresh="$emit('refresh')" />
    </BaseAccordion>

    <BaseAccordion title="Add New Trucker" :is-open="true">
      <AddNewTruckerForm :order="order" @refresh="truckerRefresh = !truckerRefresh" />
    </BaseAccordion>
  </div>
</template>

<script>
import BaseAccordion from './BaseAccordion.vue';
import RoundedButton from './RoundedButton.vue';
import AddedTruckersList from './AddedTruckersList.vue';
import AddNewTruckerForm from './form/AddNewTruckerForm.vue';

export default {
  name: 'OrdersOffers',
  components: {
    BaseAccordion,
    RoundedButton,
    AddedTruckersList,
    AddNewTruckerForm,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTruckerStatus: null,
      truckerRefresh: false,
      truckerStatus: [
        { text: 'active' },
        { text: 'pending' },
        { text: 'queued' },
        { text: 'declined' },
        { text: 'withdrawn' },
        { text: 'expired' },
        { text: 'dispatched' },
      ],
    };
  },
};
</script>
